import React, { Component } from "react";
import Tab from "./Tab";
import PropTypes from "prop-types";

export default class Tabs extends Component {
  constructor(props) {
    super(props);

    let firstChild;

    if (Array.isArray(this.props.children)) {
      firstChild = this.props.children[0];
    } else {
      firstChild = this.props.children;
    }

    this.state = {
      activeTab: firstChild ? firstChild.props.label : null,
    };

    this.onClickTabItem = this.onClickTabItem.bind(this);
  }

  onClickTabItem(tab) {
    this.setState({ activeTab: tab });
  }

  render() {
    let flatChildren = [];

    let children = this.props.children;

    if (!Array.isArray(children)) {
      children = [children];
    }

    // Allows us to conditionally render new tabs via .map
    children.map((child) => {
      if (Array.isArray(child)) {
        child.map((subChild) => {
          flatChildren.push(subChild);
        });
      } else {
        flatChildren.push(child);
      }
    });

    return (
      <div className="tabs" {...this.props}>
        <div className="tabs-header">
          <ol className="tab-list">
            {flatChildren.map((child, index) => {
              if (!child) return <></>;

              const { label } = child.props;

              return (
                <Tab
                  activeTab={this.state.activeTab}
                  key={label}
                  label={label}
                  onClick={this.onClickTabItem}
                  tabIndex={index}
                />
              );
            })}
          </ol>
        </div>
        <div className="tab-content">
          {flatChildren.map((child, index) => {
            if (!child) return null;

            return (
              <div
                key={index}
                style={
                  child.props.label === this.state.activeTab
                    ? {}
                    : { display: "none" }
                }
              >
                {child}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
};
